export default "__VITE_ASSET__0ee9da75__"